import { CancelOutlined, EditOutlined, SaveOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { FunctionComponent } from 'react'

const FormEditButtons: FunctionComponent<{
  isEditPage: boolean,
  editField: string | undefined,
  hideEditIcon: boolean,
  name: string,
  toggleEditField: (name: string) => void,
  cancelEditHandler?: () => void,
  // When provided, the edit pencil runs this instead of starting inline edit (e.g. open a picker dialog).
  onEditClick?: () => void
}> = ({isEditPage, editField, hideEditIcon, name, toggleEditField, cancelEditHandler, onEditClick}) => {
  return (
    <>
      {isEditPage && editField === '' && !hideEditIcon &&
        <Tooltip title="Edit" placement='top'>
          <IconButton onClick={() => onEditClick ? onEditClick() : toggleEditField(name)} sx={{ mr: 2, position: 'absolute', right: 0 }}>
            <EditOutlined />
          </IconButton>
        </Tooltip>
      }
      {editField === name &&
        <>
          <Tooltip title="Save" placement='top'>
            <IconButton type='submit' sx={{ mr: 2, position: 'absolute', right: 0 }}>
              <SaveOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancel" placement='top'>
            <IconButton onClick={cancelEditHandler} sx={{
              mr: 2, position: 'absolute', right: 40
            }}>
              <CancelOutlined />
            </IconButton>
          </Tooltip>
        </>
      }
    </>
  )
}

export default FormEditButtons